import TeamStatistics from 'components/general/TeamStatistics'
import Bk3Referees from './Bk3Referees';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
function Bk3TeamStats({ data }) {
  const { mirs_competition } = useUrlFriendlyToParameters()
  let stats

  if (mirs_competition === 'EG2023') {
    stats = [
      { code: 'TOUT', noData: '-' },
      { code: 'SCORE_RUN_MAX', component: 'type3', paint: 'SCORE', noData: '-' },
      { code: 'LEAD_MAX', noData: '-' },
      { code: 'UF', noData: '-' },
      { code: 'TF', noData: '-' },
      { code: 'TFOUL', noData: '-' },
      { code: 'P2', component: 'type2', noData: '-' },
      { code: 'FT', component: 'type2', noData: '-' },
      { code: 'P1', component: 'type2', noData: '-' },
    ]
  }
  else {
    stats = [
      { code: 'TOUT', noData: '-' },
      { code: 'CLG', component: 'type6', noData: '-' },
      { code: 'LEAD_MAX', noData: '-' },
      { code: 'UF', noData: '-' },
      { code: 'TFOUL10', noData: '-' },
      { code: 'TFOUL7', noData: '-' },
      { code: 'TFOUL', noData: '-' },
      { code: 'POSS', noData: '-' },
      { code: 'PLUS_MINUS', noData: '-' },
      { code: 'TO', noData: '-' },
      { code: 'DR', component: 'type5', paint: 'REB', noData: '-' },
      { code: 'OR', component: 'type5', paint: 'REB', noData: '-' },
      { code: 'DNK', noData: '-' },
      { code: 'BZR', noData: '-' },
      { code: 'BLC', noData: '-' },
      { code: 'DRV', noData: '-' },
      { code: 'ASSIST', noData: '-' },
      { code: 'HGL', noData: '-' },
      { code: 'FT', component: 'type2', noData: '-' },
      { code: 'P2', component: 'type2', noData: '-' },
      { code: 'P1', component: 'type2', noData: '-' },
      { code: 'S_EFF', noData: '-' },
    ]
  }



  return (<>
    {mirs_competition === 'EG2023'
      ?
      <>
        <TeamStatistics data={data?.results} stats={stats} />
        <Bk3Referees data={data} />
      </>
      :
      <>
        <TeamStatistics data={data?.results} stats={stats} />
        <Bk3Referees data={data} />
      </>
    }

  </>);
}

export default Bk3TeamStats;